import { Checkbox, Input } from "rsuite";
import format_number from "../../../../Helpers/number_formatter";

const RowOfTable = ({ index, model, data, keyName, setModel, grouppedBy }) => {
  const handleCheckboxChange = () => {
    let prices = [...model.prices];
    data[keyName].forEach((el, idx) => {
      const key = `${el.hotelMakkahName} - ${el.hotelMadinahName} - ${el.typeTraveler}`;
      const _index = prices.findIndex(
        (_el) =>
          `${_el.hotelMakkahName} - ${_el.hotelMadinahName} - ${_el.typeTraveler}` ===
          key
      );
      if (_index !== -1) {
        prices[_index] = {
          ...prices[_index],
          isHidden: !prices[_index].isHidden,
        };
      }
    });
    grouppedBy(prices);
    setModel((prev) => ({ ...prev, prices }));
  };

  const updatePrice = (newPrice, entry) => {
    const updatedPrices = [...model.prices];
    const priceIndex = updatedPrices.findIndex(
      (price) =>
        price.hotelMakkahName === entry.hotelMakkahName &&
        price.hotelMadinahName === entry.hotelMadinahName &&
        price.typeTraveler === entry.typeTraveler &&
        price.arrangementMadinahDesignation ===
          entry.arrangementMadinahDesignation &&
        price.arrangementMakkahDesignation ===
          entry.arrangementMakkahDesignation
    );

    if (priceIndex !== -1) {
      updatedPrices[priceIndex] = {
        ...updatedPrices[priceIndex],
        price: parseFloat(newPrice),
      };
    }
    setModel((prev) => ({ ...prev, prices: updatedPrices }));
  };

  return (
    <tr
      style={{
        background: index % 2 ? "rgb(244,81,108,0)" : "rgb(70,103,209,0.2)",
        borderBottom: "3px solid #eee",
      }}
    >
      <td>
        <Checkbox
          onChange={handleCheckboxChange}
          checked={
            !model.prices.filter((el) =>
              data[keyName].find(
                (_el) => JSON.stringify(el) === JSON.stringify(_el)
              )
            )[0]?.isHidden
          }
        />
      </td>
      <td>
        <h6>{keyName}</h6>
      </td>
      <td>{format_number(model.b2Bcommission + model.commission)}</td>
      {["SIMPLE", "DOUBLE", "TRIPLE", "QUAD", "FAMILIALE", "SUITE"].map(
        (type, typeIndex) => {
          const entry = data[keyName].find(
            (el) =>
              el.arrangementMadinahDesignation.toUpperCase().includes(type) &&
              el.arrangementMakkahDesignation.toUpperCase().includes(type)
          );

          const arrangementMadinahDesignation =
            entry?.arrangementMadinahDesignation;
          const arrangementMakkahDesignation =
            entry?.arrangementMakkahDesignation;

          const matchingPriceObject = model.prices.find(
            (price) =>
              price.hotelMakkahName === entry?.hotelMakkahName &&
              price.hotelMadinahName === entry?.hotelMadinahName &&
              price.typeTraveler === entry?.typeTraveler &&
              price.arrangementMadinahDesignation ===
                arrangementMadinahDesignation &&
              price.arrangementMakkahDesignation ===
                arrangementMakkahDesignation
          );

          const priceValue = matchingPriceObject
            ? matchingPriceObject.price
            : entry?.baseCost + model.b2Bcommission + model.commission || 0;
          const baseCost =
            entry?.baseCost + model?.b2Bcommission + model?.commission;

          return (
            <td key={`${type}-${typeIndex}`}>
              {entry ? (
                <>
                  <b>{format_number(baseCost)}</b>
                  <Input
                    value={priceValue || 0}
                    onChange={(price) => {
                      updatePrice(price, entry);
                    }}
                  />
                </>
              ) : (
                0
              )}
            </td>
          );
        }
      )}
    </tr>
  );
};

export default RowOfTable;
